import "./Search.css";
import { withRouter } from "react-router";
import { Link } from "react-router-dom";
import Course from "./Course.js";
import Pagination from "./Pagination.js";
import { v4 as uuidv4 } from 'uuid';
import PropTypes from "prop-types";

function Search(props) {
  return (
    <div className="search-courses">
      <div className="search-courses-bar">
        <Link
          className="close-search"
          to="/"
          onClick={() => {
            props.updateQuery("");
            props.delayedRetrieval("");
          }}
        />
        <div className="search-courses-input-wrapper">
          <input
            type="text"
            placeholder="Search by course title or course number"
            value={props.query}
            onChange={event => {
              props.updateQuery(event.target.value);
              props.delayedRetrieval(event.target.value);
            }}
          />
        </div>
      </div>
      <div className="search-courses-results">
        <ol className="courses-grid">
          {props.retrieved.map(course => (
            <Course
              course={course}
              key={uuidv4()}
              updateCourse={props.updateCourse}
              removeCourse={props.removeCourse}
            />
          ))}
        </ol>
        <Pagination
          numRetrieved={props.retrieved.length}
          pagination={props.pagination}
          links={props.links}
          navRetrieved={props.navRetrieved}
        />
      </div>
    </div>
  );
}

export default withRouter(Search);

Search.propTypes = {
  query: PropTypes.string.isRequired,
  updateQuery: PropTypes.func.isRequired,
  retrieved: PropTypes.arrayOf(
    PropTypes.shape({
      number: PropTypes.string,
      title: PropTypes.string,
      term: PropTypes.string,
      status: PropTypes.string,
      _id: PropTypes.string,
      color: PropTypes.string,
    })
  ),
  updateCourse: PropTypes.func.isRequired,
  removeCourse: PropTypes.func.isRequired,
  pagination: PropTypes.shape({
    page: PropTypes.number,
    limit: PropTypes.number,
    last: PropTypes.number,
    total: PropTypes.number,
  }),
  links: PropTypes.shape({
    first: PropTypes.string,
    last: PropTypes.string,
    next: PropTypes.string,
    prev: PropTypes.string,
  }),
  navRetrieved: PropTypes.func.isRequired,
}
